module.exports = __webpack_public_path__ + "img/login.e3b9e377.png";